import styled from "styled-components";

const ChartContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 16px;

  .recharts-text {
    font-size: 0.75rem;
  }

  h2 {
    width: 100%;
    text-align: left;
    color: #222529;
    font-size: 1rem;
    font-weight: bold;
    margin: 0 0 16px 0;
  }
`;

const DatePicker = styled.ul`
  display: flex;
  justify-content: space-between;
  background-color: #f1f3f5;
  width: 100%;
  padding: 2px;
  border-radius: 4px;
  margin-bottom: 16px;
  font-size: 0.75rem;

  li {
    text-align: center;
    width: 100%;
    border-radius: 4px;
    cursor: pointer;
    padding: 4px;
  }

  li.active {
    background-color: #ff7a00;
    color: white;
    transition: width 1s;
  }
`;

const MarketPriceTable = styled.table`
  width: 100%;
  margin-top: 26px;
  table-layout: fixed;

  tr {
    text-align: center;
  }

  th {
    background-color: #f1f3f5;
    padding: 6px 0;
    font-size: 0.75rem;
    font-weight: bold;
    color: #222529;
  }

  td {
    padding: 6px 0;
    font-size: 0.75rem;
    font-weight: regular;
    color: #4a5056;
  }
`;

const MoreButton = styled.button`
  width: 100%;
  cursor: pointer;
  background-color: white;
  color: #4a5056;
  border: 1px solid #dfe2e6;
  border-radius: 8px;
  font-size: 0.875rem;
  padding 12px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 16px;

  img {
    max-width: 24px;
  }
`;

export { ChartContainer, DatePicker, MarketPriceTable, MoreButton };
